import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { mediumHeightScreens, smallScreens } from 'components/common/fontElements';

export const Container = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
`;

export const CustomerDetailsFormHeader = styled.div`
  font-size: 15px;
  margin-bottom: 16px;
  font-weight: 1200;
  color: ${colors.black1};
`;

export const CustomerDetailsFormContainer = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  padding: 30px 40px 30px;
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
  width: 100%;
  font-family: Lato;
  border-bottom: 1px solid ${colors.lightGray15};
`;

export const CustomerDetailsHeaderContainer = styled.div`
  padding: 30px 40px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
`;

export const Title = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.black1};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const SubTitle = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const PageHeader = styled.div`
  padding: 30px 0px 20px;
  border-bottom: 1px solid #d8e8ef;
  text-align: center;
`;

export const Icon = styled.img`
  padding-bottom: 20px;
`;

export const MacroContainer = styled.div`
  padding: 0px 10px 50px;
  position: relative;
`;
